import { motion } from "framer-motion";

function SuspenseContent() {
  return (
    <div className="w-full min-h-[60vh] flex flex-col items-center justify-center gap-4 px-4">
      <motion.div
        initial={{ scale: 0.7, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-700 to-brand-800 flex items-center justify-center shadow-brand">
          <img
            src="/Main.png"
            alt=""
            className="w-9 h-9 object-contain"
          />
        </div>
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
          className="absolute -inset-1.5 rounded-2xl border-2 border-transparent border-t-brand-700 border-r-brand-500"
        />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.4 }}
        className="text-sm text-ink-muted font-medium"
      >
        Loading…
      </motion.p>
    </div>
  );
}

export default SuspenseContent;
